exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".viewCourse---177CT {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  background-color: #1981c4;\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  color: white;\n  margin: 0 auto;\n  border: none;\n  outline: none; }\n\n.icon---19Dk3 {\n  width: 16px;\n  margin: 6px auto; }\n\n.icon---19Dk3 svg path {\n    fill: #fff !important; }\n", ""]);

// exports
exports.locals = {
	"viewCourse": "viewCourse---177CT",
	"icon": "icon---19Dk3"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/view-course/index.scss
// module id = 1224
// module chunks = 3